export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-logo-f4ffdf80ca3d5212dcf9072bde0aa89a.png";